import useVaults from "@/hooks/api/useVaults";
import { useReduceVaultAssets } from "@/hooks/data/filters/useReduceUnderlyingAssets";
import { usePersistState } from "@/hooks/usePersistState";
import type { SortField } from "@repo/core-ui";
import { useEffect, useState } from "react";
import { useSearchParams } from "next/navigation";
import { useStoredDataDispatch } from "@/store/Context";

export default function useApplyCategoryFilter(enabled: boolean = false) {
  const searchParams = useSearchParams();
  const storedDispatch = useStoredDataDispatch();
  const [isProcessed, setIsProcessed] = useState(false);

  const [, setSorting] = usePersistState<SortField>(`sorting-Vaults`, undefined);

  const { data, isLoading } = useVaults("fully-cached");

  const category = searchParams.get("category");
  const filter = searchParams.get("filter");
  const filterAsset = searchParams.get("filter_asset");

  const filteredTokens = useReduceVaultAssets({ vaults: data, filterNamePattern: filterAsset?.split(",") });

  useEffect(() => {
    if (!isProcessed && !isLoading) {
      if (enabled) {
        if (filter) {
          storedDispatch({ type: "clearAllFilters" });
          switch (filter) {
            case "stable-apy":
              storedDispatch({ type: "setFilter", filter: { name: "token", values: filteredTokens } });
              storedDispatch({ type: "setFilter", filter: { name: "apy", values: { min: 5, max: 350 } } });
              break;
            case "stable-tvl":
              storedDispatch({ type: "setFilter", filter: { name: "token", values: filteredTokens } });
              storedDispatch({ type: "setFilter", filter: { name: "tvl", values: { min: 100_000, max: 2_000_000_000 } } });
              break;
            case "stable-rewards":
              storedDispatch({ type: "setFilter", filter: { name: "token", values: filteredTokens } });
              storedDispatch({ type: "setFilter", filter: { name: "vaults_with_rewards", values: true } });
              break;
            case "eth-on-arbitrum":
              storedDispatch({ type: "setFilter", filter: { name: "token", values: filteredTokens } });
              storedDispatch({ type: "setFilter", filter: { name: "chain", values: [42161] } });
              break;
            case "eth-on-base":
              storedDispatch({ type: "setFilter", filter: { name: "token", values: filteredTokens } });
              storedDispatch({ type: "setFilter", filter: { name: "chain", values: [8453] } });
              break;
          }

          setSorting({ field: "apy", direction: "DESC" });
        } else {
          if (category) {
            storedDispatch({ type: "setFilter", filter: { name: "yield_type", values: [category] } });
          }
        }
        setIsProcessed(true);
      }
    }
  }, [category, enabled, filter, filteredTokens, isLoading, isProcessed, searchParams, setSorting, storedDispatch]);
}
